import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import SpotifyAnalyzer from './pages/SpotifyAnalyzer';
import HaikeiArt from './pages/HaikeiArt';
import HftMemoir from './pages/HftMemoir';
import Neo4jContacts from './pages/Neo4jContacts';
import Arutairu from './pages/Arutairu';

function App() {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: 'background.default', 
      display: 'flex', 
      flexDirection: 'column',
      overflowX: 'hidden',
      width: '100%'
    }}>
      <ScrollToTop />
      <Navbar />
      <Box sx={{ flexGrow: 1, overflowX: 'hidden', width: '100%' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/spotify-analyzer" element={<SpotifyAnalyzer />} />
          <Route path="/haikei" element={<HaikeiArt />} />
          <Route path="/hft-memoir" element={<HftMemoir />} />
          <Route path="/neo4j-contacts" element={<Neo4jContacts />} />
          <Route path="/arutairu" element={<Arutairu />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;
